export default "/images/a6158274d9071521ad024a2c4b019c6c.avif";